module.exports = "/images/cws-logo.png?8eb2a7491513ab36d582152aaffbd6c7";